import React from 'react';
import { Plus, X } from 'lucide-react';
import imgUrbanIcon from '../../../assets/PNG/urban_icon.png';
import imgUrbanCompassWhite from '../../../assets/PNG/urban_compass_logo_white.png';
import imgUrbanCompassBlack from '../../../assets/PNG/urban_compass_logo_black.png';
import * as S from './LeftSidebar.styles';
import { useAppSharedData } from '../../../hooks/useAppSharedData';

const LeftSidebar = ({ isOpen, onClose, onNewChat, themeMode }) => {
  // fetch data from the shared hook
  const { data } = useAppSharedData();

  const handleNewChatClick = () => {
    const confirmed = window.confirm(
      'Start a new chat? Your current conversation will be cleared.'
    );

    if (confirmed) {
      onNewChat();
      onClose();
    }
  };

  const handleNavigateToWebsite = () => {
    open('https://urbancompasssoftware.com/', '_blank');
  };

  return (
    <>
      <S.MobileOverlay $isOpen={isOpen} onClick={onClose} />
      <S.SidebarContainer $isOpen={isOpen}>
        <div>
          <S.Header>
            <S.LogoContainer>
              <S.LogoImage>
                {data?.logoUrl ? (
                  <img src={data.logoUrl} alt="Council logo" />
                ) : (
                  <img src={imgUrbanIcon} alt="Urban Compass" />
                )}
              </S.LogoImage>
              <S.LogoText>{data?.councilName || 'Urban Compass'}</S.LogoText>
            </S.LogoContainer>
            <S.CloseButton onClick={onClose}>
              <X />
            </S.CloseButton>
          </S.Header>
          <S.NewChatSection>
            <S.NewChatButton onClick={handleNewChatClick}>
              <Plus />
              <span>New Chat</span>
            </S.NewChatButton>
          </S.NewChatSection>
        </div>

        {/* tab menu hide for now */}

        {/* <S.Navigation>
          <S.NavButton>
            <HelpCircle />
            <span>Help & Support</span>
          </S.NavButton>
          <S.NavButton>
            <MessageSquare />
            <span>Explore</span>
          </S.NavButton>
          <S.NavButton>
            <Clock />
            <span>History</span>
          </S.NavButton>
        </S.Navigation> */}

        <S.PoweredBySection onClick={handleNavigateToWebsite}>
          <S.PoweredByContent>
            <S.PoweredByText>Powered By</S.PoweredByText>
            <S.PoweredByLogo>
              <img
                src={themeMode === 'dark' ? imgUrbanCompassBlack : imgUrbanCompassWhite}
                alt="Urban Compass"
              />
            </S.PoweredByLogo>
          </S.PoweredByContent>
        </S.PoweredBySection>
      </S.SidebarContainer>
    </>
  );
};

export default LeftSidebar;
